export const mainCaption = '© Ask-AI {{year}} | <Link>info@ask-ai.com</Link>';
export const joinUs = 'Join us!';
export const social = {
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
};
